import React from "react";

function AboutMainIntro(props) {
  return (
    <div
      id="aboutus__intro-title"
      className="aboutus__intro-title slow__display"
    >
      <img id="logo" src="/img/logo.jpg" />
      <div className="Intro_Title-Inner">
        <p className="removeMargin">About</p>
        <h2 className="removeMargin">childVision</h2>
        <p className="removeMargin"> Academy</p>
      </div>
    </div>
  );
}

export default AboutMainIntro;
